import {Utilities as U} from '@shared/utilities/utilities.model';
import {Place} from '../../../appointments/models/appointment.model';

export class PlaceRepair extends Place {
	id?: string;
	fiscal_code: string;
	type_description		      : string = '';
	address							      : string = '';
	address_number			      : string = '';
	ald_commodity_id		      : number | string ;
	idd									      : number ;
	ald_supplier_code		      : number ;
	contact_phone				      : string = '';
	municipality				      : string = '';
	name								      : string = '';
	place_id						      : string = '';
	type								      : string = '';
	zip_code						      : string = '';
	email								      : string = '';
	region							      : string = '';
	province_code				      : string = '';
	flag_delivery_point_label	: string = '';
	flag_return_point_label		: string = '';
	flag_premium_point_label	: string = '';
	flag_base_ald_label				: string = '';
	flag_service_box_label		: string = '';
	vat_number      		      : string = '';
	address_label      		    : string = '';
	type_label		     		    : string = '';

	constructor(model?: any) {

		super(model);
		
		if (U.isEmpty(model)) {
			return;
		}
		
		this.type_description 		     = model.type_description;
		this.address 							     = model.address;
		this.address_number 			     = model.address_number;
		this.ald_commodity_id 		     = model.ald_commodity_id;
		this.idd 									     = model.ald_commodity_id;
		this.ald_supplier_code 		     = model.ald_supplier_code;
		this.contact_phone 				     = model.phone;
		this.municipality 				     = model.municipality;
		this.name 								     = model.name;
		this.place_id 						     = model.id;
		this.type 								     = Place.TYPE_SERVICE_POINT;
		this.zip_code 						     = model.zip_code;
		this.email 								     = model.email;
		this.region 							     = model.region;
		this.province_code 				     = model.province_code;
		this.fiscal_code  				     = model.fiscal_code;
		this.vat_number  				       = model.vat_number;

		// sistemare queste label in un ENUM, 
		// questa cosa legacy è inguardabile
		this.flag_delivery_point_label = model.flag_delivery_point ? 'Delivery Point' : '';
		this.flag_return_point_label 	 = model.flag_return_point ? 'Return Point' : '';
		this.flag_premium_point_label  = model.flag_premium_point ? 'Premium Point' : '';
		this.flag_base_ald_label 			 = model.flag_base_ald ? 'Base ALD' : '';
		this.flag_service_box_label 	 = model.flag_service_box ? 'Service Box' : '';
		
		// inserita per sistemare un bug
		// Questa classe è la brutta copia di CommodityModel
		this.id 						     			 = model.id;

		// i metodi davano dei nullpointer,
		// perché purtroppo non vengono sempre instanziati gli oggetti
		// ma si usa la classe soltanto come tipo
		// PS: i metodi richiamati molte volte quand sono nell'HTML 
		this.address_label			       = this.getAddressLabel();
		this.type_label			           = this.getTypeLabel();
	}

	getAddressLabel(): string {
		return `${this.address} , ${this.address_number}, ${this.zip_code} - ${this.municipality} - ${this.province_code}`;
	}

	getTypeLabel(): string {
		return (
			[
				this.flag_delivery_point_label,
				// this.flag_return_point_label,
				this.flag_premium_point_label,
				this.flag_base_ald_label,
				this.flag_service_box_label,
			]
			.filter(x => x).join('/')
		);

	}
}
